// extracted by mini-css-extract-plugin
export default {"melodyVideo":"xJ-z","isFullWidth":"yJ-z","landingPageVideo":"zJ-z","play":"AJ-z","iframeVideo":"BJ-z","playHidden":"CJ-z","fullwidth":"DJ-z"};